import React, { Fragment } from 'react'
import request from 'graphql-request'
import { Flex, Box } from 'rebass'
import styled from 'styled-components'
import media from '../../../utils/style'
import { types, sorts } from '../../../utils/query-variables'
import ContentSectionHero from '../../../components/ContentSectionHero'
import FullReview from '../../../components/FullReview'
import FullReviewFilters from '../../../components/FullReviewFilters'
import LoadMoreButton from '../../../components/LoadMoreButton'
import LoadingSpinner from '../../../components/LoadingSpinner'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  background-color: #eef4f9;

  ${media.MediumScreenUp`
    padding: 40px 40px 20px;
  `}

  ${media.LargeScreenUp`
    padding: 80px 80px 20px;
  `}

  ${media.GiantScreenUp`
    padding: 160px 80px 20px;
  `}
`

const ReviewsWrapper = styled(Box)`
  max-width: 1400px;
  width: 100%;
`

class ReviewsWidget extends React.Component {
  constructor(props) {
    super(props)
    this.filter = this.filter.bind(this)
    this.state = {
      filterValue: this.props.sortType,
      variables: {
        skip: 0,
        limit: 3
      }
    }
  }

  filter(e) {
    this.setState(
      {
        filterValue: e.value,
        variables: {
          ...this.state.variables,
          skip: 0,
          limit: 3,
          sort: sorts.reviews[e.value]
        }
      },
      this.fetchReviews
    )
  }

  loadMore() {
    const { skip, limit } = this.state.variables
    this.setState(
      {
        variables: {
          ...this.state.variables,
          skip: skip,
          limit: limit + 10
        }
      },
      this.fetchReviews
    )
  }

  async fetchReviews(isLoadMore) {
    let generatedQueryVars = Object.entries(this.state.variables)
      .map((kv) => `$${kv[0]}:${types[typeof kv[1]].type}`)
      .join(',')

    generatedQueryVars = generatedQueryVars + ',$location:[String]'

    let generatedVarForwarding = Object.keys(this.state.variables)
      .map((k) => `${k}: $${k}`)
      .join(', ')

    generatedVarForwarding = generatedVarForwarding + ', location: $location'

    const query = `
    query getReviews(${generatedQueryVars}) {
      review(${generatedVarForwarding}) {
        _id
        name
        reviewId
        content
        rating
        location
        reviewDate
        createdDate
      }
    }`

    const transformedVars = Object.keys(this.state.variables).reduce(
      (object, key) => {
        object[key] = types[typeof this.state.variables[key]].transform
          ? types[typeof this.state.variables[key]].transform(
              this.state.variables[key]
            )
          : this.state.variables[key]
        return object
      },
      {}
    )

    transformedVars.location = (this.props.reviewEntities || []).map(
      (e) => e.apiId
    )

    try {
      const { review } = await request(
        `${process.env.GATSBY_API_URL}/graphql`,
        query,
        transformedVars
      )

      if (review) {
        const mergedReview = isLoadMore
          ? [...this.state.review, ...review]
          : review
        this.setState({ review: mergedReview })
      }
    } catch (e) {
      console.error(e)
    }
  }

  async UNSAFE_componentWillMount() {
    await this.fetchReviews()
  }

  render() {
    return (
      <Fragment>
        <ContentSectionHero
          title={this.props.title}
          reversed
          alignment={'center'}
          relaxed
          ctaHref={this.props.ctaHref}
          ctaLabel={this.props.ctaText}
          wrapperProps={{
            pt: 1,
            pb: 3
          }}
        >
          <p>{this.props.description}</p>
        </ContentSectionHero>
        <FlexWrapper mx={'auto'}>
          <ReviewsWrapper mx={'auto'}>
            <FullReviewFilters
              filter={this.filter}
              filterValue={this.state.filterValue}
            />
            {this.state.review && (
              <>
                {this.state.review.map((review, i) => (
                  <FullReview key={i} review={review} />
                ))}
                <LoadMoreButton onClick={(e) => this.loadMore(e)}>
                  Load More
                </LoadMoreButton>
              </>
            )}
            {!this.state.review && <LoadingSpinner />}
          </ReviewsWrapper>
        </FlexWrapper>
      </Fragment>
    )
  }
}

export default ReviewsWidget
